export class StoreConfig {
  constructor({ id, store_id, fillings = {}, printerConfig = null }) {
    this.id = id;
    this.store_id = store_id;
    this.fillings = fillings; // { [key]: { name: string, enabled: boolean, color: string } }
    this.printerConfig = printerConfig; // { ip: string, enabled: boolean, protocol: 'http'|'https' } | null
  }

  toJson() {
    return {
      id: this.id,
      store_id: this.store_id,
      fillings: this.fillings,
      ...(this.printerConfig && { printerConfig: this.printerConfig }),
    };
  }

  static fromFirebase(doc) {
    const data = doc.data();
    return new StoreConfig({
      id: doc.id,
      store_id: data.store_id,
      fillings: data.fillings || {},
      printerConfig: data.printerConfig || null,
    });
  }

  // Helper methods
  getEnabledFillings() {
    return Object.entries(this.fillings)
      .filter(([_, filling]) => filling.enabled)
      .reduce((acc, [key, filling]) => {
        acc[key] = filling;
        return acc;
      }, {});
  }

  toggleFilling(key) {
    if (this.fillings[key]) {
      this.fillings[key].enabled = !this.fillings[key].enabled;
    }
  }

  upsertFilling(key, name, color, enabled = true) {
    this.fillings[key] = {
      name,
      color,
      enabled,
    };
  }

  deleteFilling(key) {
    delete this.fillings[key];
  }
}
